const dictionaryBotConfigs = require("./dictionary.bots");
const regex = require("./regex");
const topFilterConfigs = require("./topFilterConfigs");
const font = require("./font");
const notifications = require("./notifications");
const dictionaryUtil = require("./dictionary.util");
const socialMediaConfigs = require("./socialMedia").configs;

const dictionaryConfigs = [
  {
    key: "bio",
    type: "string",
    maxLength: 200,
  },
  ...dictionaryBotConfigs,
  {
    key: "comment_id",
    label: "comment id",
    type: "number",
  },
  {
    key: "comment_level",
    label: "comment level",
    type: "number",
  },
  {
    key: "comment_reply_id",
    label: "comment reply id",
    type: "number",
  },
  {
    key: "comment_text",
    label: "comment",
    type: "string",
    minLength: 10,
    maxLength: 5000,
    minWords: 3,
    helpers: [
      "Anything that starts with an '@' (likes this: '@dostoyevsky1866') is considered a user mention. Anything that starts with a '#' (likes this: '#litlit') is considered a hashtag mention. Any mentions will get parsed as tags.",
      // "To insert links, wrap your link in parantheses and, before it, wrap the link label in square brackets, like this: '[check this out](https://uncookd.com)'."
    ],
  },
  {
    key: "content_type",
    type: "string",
    whitelist: ["draft_page"],
  },
  {
    key: "description",
    type: "string",
    maxLength: 300,
  },
  {
    key: "display_name",
    label: "display name",
    type: "string",
    maxLength: 30,
    blacklist: dictionaryUtil.blacklist.name,
  },
  {
    key: "email",
    type: "string",
    maxLength: 500,
    regex: [regex.whitespace, regex.email],
  },
  {
    key: "error",
    type: "object",
    whitelistKeys: ["pathname", "message", "stack"],
  },
  {
    key: "excludeKeys",
    label: "Exclude keys",
    type: "array",
    typeArrayItem: "string",
    whitelistArray: ["hashtag_recommendations"],
  },
  {
    key: "feedback",
    type: "string",
    minLength: 15,
    maxLength: 2000,
    minWords: 3,
  },
  {
    key: "filter",
    type: "string",
    whitelist: [
      "stories",
      "comments",
      "confirmed",
      "requests",
      "hashtags",
      "users",
      "false",
      ...topFilterConfigs.map((topFilterConfig) => topFilterConfig.label),
    ],
  },
  {
    key: "filter2",
    type: "string",
    whitelist: [
      "all",
      "author subscriptions only",
      "hashtag subscriptions only",
    ],
  },
  {
    key: "font_family",
    label: "font family",
    type: "string",
    maxLength: 100,
    whitelist: font.configs.map((fontConfig) => fontConfig.key),
  },
  {
    key: "hashtag",
    type: "string",
    maxLength: 30,
  },
  {
    // MYSQL: Match maxLengthArrayItem * maxLengthArrayItem + 30 with "draft"
    //        table column: TINYTEXT --> maxLength of 255 characters.
    key: "hashtag_list",
    label: "hashtag list",
    type: "array",
    typeArrayItem: "string",
    maxLengthArray: 7,
    maxLengthArrayItem: 30,
    helpers: [
      "Add up to 7 hashtags (with a 30 character limit for each hashtag) to help categorize your story and make it more discoverable on the homepage (#genre).",
      "Tip: Is this a series? Start a hashtag that users can subscribe to and follow.",
    ],
  },
  {
    key: "id",
    type: "number",
  },
  {
    key: "interruptionIndex",
    label: "interruption index",
    type: "number",
  },
  {
    key: "is_nsfw",
    label: "NSFW",
    type: "booleanNumber",
  },
  {
    key: "is_private",
    label: "account privacy",
    type: "booleanNumber",
  },
  {
    key: "is_shareable",
    label: "story sharing",
    type: "booleanNumber",
  },
  {
    key: "is_verified",
    label: "account verification",
    type: "booleanNumber",
  },
  {
    // First four whitelisted items determine search ui components (i.e. order is important).
    key: "list",
    type: "string",
    whitelist: [
      "user", //          For search
      "story", //         For search
      "comment", //       For search
      "hashtag", //       For search
      "posts", //         For profile
      "bookmarks", //     For profile
      "subscribers", //   For profile
      "subscriptions", // For profile
      "comments", //      For story
      "replies", //       For comment
      "likes", //         For story/comment
      "errors", //        For admin
      ...notifications.account.map(
        (notificationAccountConfig) => notificationAccountConfig.key
      ),
    ],
  },
  {
    key: "next",
    type: "base64",
    maxLength: 2000,
  },
  {
    key: "note_by_email",
    label: "email notifications",
    type: "booleanNumber",
  },
  {
    key: "password",
    ...dictionaryUtil.preset.password,
  },
  {
    key: "password1",
    label: "password",
    ...dictionaryUtil.preset.password,
  },
  {
    key: "password2",
    label: "confirmation password",
    match: "password1",
    ...dictionaryUtil.preset.password,
  },
  {
    key: "profile_id",
    label: "profile id",
    type: "number",
  },
  {
    key: "q",
    label: "query",
    type: "string",
    minLength: 2,
    maxLength: 150,
  },
  {
    key: "q_caption",
    label: "query caption",
    type: "booleanString",
  },
  {
    key: "q_source",
    label: "query source",
    type: "string",
    whitelist: [
      "desktop_search",
      "tablet_search",
      "mobile_search",
      "hashtag_list",
      "search_page",
    ],
  },
  {
    key: "requestKeys",
    label: "Request keys",
    type: "array",
    typeArrayItem: "string",
    whitelistArray: [
      "is_verified",
      "display_name",
      "joined_at",
      "bio",
      "count_stories",
      "count_subscribers",
      "subscription",
    ],
  },
  {
    key: "rich_text_story",
    label: "story",
    type: "string",
    minLengthHTML: 15,
    minWordsHTML: 5,
    maxLengthHTML: 1000000, // MEDIUMTEXT === 16,777,215 maximum characters; ~10 characters / word+space in a 100,000 word story.
    ignoreIsSanitized: true,
  },
  {
    key: "show_email",
    label: "show email",
    type: "booleanNumber",
  },
  {
    key: "slug",
    type: "string",
    maxLength: 255, // Max mysql key length.
    regex: [regex.whitespace],
  },
  {
    key: "sort",
    type: "string",
    whitelist: ["newest", "top", "trending", "alphabetical", "chronological"],
  },
  {
    key: "story_id",
    label: "story id",
    type: "number",
  },
  {
    key: "subscriber_id",
    label: "subscriber id",
    type: "number",
  },
  {
    key: "subscription_id",
    label: "subscription id",
    type: "number",
  },
  {
    key: "title",
    type: "string",
    maxLength: 100,
  },
  {
    key: "token",
    type: "string",
    maxLength: 2000, // To account for maximum e-mail length.
  },
  {
    key: "updateKey",
    label: "Update key",
    type: "string",
    whitelist: ["note_last"],
  },
  {
    key: "user_id",
    label: "user id",
    type: "number",
  },
  {
    key: "username",
    type: "string",
    maxLength: 25,
    regex: [regex.whitespace, regex.specialChar],
    blacklist: dictionaryUtil.blacklist.name,
  },
  {
    key: "webpushSubscription",
    type: "string",
    maxLength: 1000,
  },
  {
    key: "website",
    type: "string",
    maxLength: 200,
  },
  {
    key: "write_autosave",
    label: "draft autosave",
    type: "booleanNumber",
  },
  ...notifications.push.map((notificationConfig) => ({
    key: notificationConfig.key,
    label: notificationConfig.label_data,
    type: "booleanNumber",
  })),
  ...socialMediaConfigs.map((socialMediaConfig) => ({
    key: socialMediaConfig.machine_name,
    label: socialMediaConfig.label,
    type: "string",
    maxLength: 250,
  })),
];

const dictionary = {
  configs: dictionaryConfigs,
  get: dictionaryUtil.get(dictionaryConfigs),
};

module.exports = dictionary;
